/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';

import { useIntersectionObserver } from '../../hooks/useObserver';

import DrawnArrowIcon from '../icons/DrawnArrow';

const propTypes = {
    // id: PropTypes.string.isRequired, // otherwise the masking is borked
    onObserve: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    onObserve: false,
    color: 'currentColor',
    className: null,
};

const DrawnArrow = ({ color, onObserve, className }) => {
    const [drawn, setDrawn] = useState(false);

    const {
        ref,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '0%' });

    useEffect(() => {
        if (isIntersecting && onObserve) {
            setDrawn(true);
        }
    }, [isIntersecting]);

    return (
        <div ref={ref}>
            <DrawnArrowIcon color={color} drawn={drawn} className={className} />
        </div>
    );
};

DrawnArrow.defaultProps = defaultProps;
DrawnArrow.propTypes = propTypes;

export default DrawnArrow;
